module.exports = __webpack_public_path__ + "img/phone.a86cfff4.svg";